import * as React from "react";

import gettext from "../../shared/utils/gettext";

const MeasurementImagePopup = ({ name, time, imageId }) => {
  const [status, setStatus] = React.useState("loading");
  const src = `/api/v3/cloud_farm/data/datasets/measurement_image/${encodeURIComponent(imageId)}/`;

  if (status === "error") {
    return (
      <div>
        <p style={{ lineHeight: "0px" }}>{name}</p>
        <p>{gettext("Could not load image")}</p>
        {time ? <p style={{ lineHeight: "0px" }}>{time}</p> : null}
      </div>
    );
  }

  return (
    <div>
      <p style={{ lineHeight: "0px" }}>{name}</p>
      {status === "loading" ? <p>{gettext("loading")}</p> : null}
      <img
        src={src}
        alt={name}
        style={{
          maxWidth: "200px",
          maxHeight: "200px",
          display: status === "loaded" ? "block" : "none",
        }}
        onLoad={() => setStatus("loaded")}
        onError={() => setStatus("error")}
      />
      {time ? <p style={{ lineHeight: "0px" }}>{time}</p> : null}
    </div>
  );
};

export default MeasurementImagePopup;
